import { MasterConfig } from '../masters/master-config';

export const CSSD_MASTER_CONFIGS: Record<string, MasterConfig> = {
  'cssd-instrument-categories': {
    masterType: 'cssd_instrument_category', routeSlug: 'cssd-instrument-categories',
    apiSlug: 'cssd-instrument-categories', dataKey: 'records', singularDataKey: undefined,
  },
  'cssd-departments': {
    masterType: 'cssd_department', routeSlug: 'cssd-departments',
    apiSlug: 'cssd-departments', dataKey: 'records', singularDataKey: undefined,
  },
  'cssd-chemical-indicators': {
    masterType: 'cssd_chemical_indicator', routeSlug: 'cssd-chemical-indicators',
    apiSlug: 'cssd-chemical-indicators', dataKey: 'records', singularDataKey: undefined,
  },
  'cssd-washing-methods': {
    masterType: 'cssd_washing_method', routeSlug: 'cssd-washing-methods',
    apiSlug: 'cssd-washing-methods', dataKey: 'records', singularDataKey: undefined,
  },
  'cssd-storage-locations': {
    masterType: 'cssd_storage_location', routeSlug: 'cssd-storage-locations',
    apiSlug: 'cssd-storage-locations', dataKey: 'records', singularDataKey: undefined,
  },
  'cssd-rejection-reasons': {
    masterType: 'cssd_rejection_reason', routeSlug: 'cssd-rejection-reasons',
    apiSlug: 'cssd-rejection-reasons', dataKey: 'records', singularDataKey: undefined,
  },
  'cssd-test-indicators': {
    masterType: 'cssd_test_indicator', routeSlug: 'cssd-test-indicators',
    apiSlug: 'cssd-test-indicators', dataKey: 'records', singularDataKey: undefined,
  },
};

const CSSD_MASTER_LABEL_OVERRIDES: Record<string, string> = {
  'cssd-storage-locations': 'Ward/Room',
};

export const CSSD_MASTER_TYPE_OPTIONS = Object.entries(CSSD_MASTER_CONFIGS).map(([key, config]) => ({
  value: key,
  label: CSSD_MASTER_LABEL_OVERRIDES[key]
    ?? config.masterType.replace(/^cssd_/, '').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
}));
